import Vue from 'vue';
import Router from 'vue-router';
import store from './store';
import accessDenied from './views/AccessDenied.vue';
import ErrorMessage from './views/ErrorMessage.vue';
import Dashboard from './views/dashboard/DashboardContent.vue';
import DataImport from './views/dataImport/DataImport.vue';
import FmeImportResults from './views/dataImport/FmeImportResults.vue';
import OwsOverview from './views/ows/OwsOverview.vue';
import OwsDetail from './views/ows/OwsDetail.vue';
import ThemeLayerOverview from './views/themelayers/ThemeLayerOverview.vue';
import ThemeLayerDetail from './views/themelayers/ThemeLayerDetail.vue';
import ThemeGroupsOverview from './views/themegroups/ThemeGroupsOverview.vue';
import ThemeGroupDetail from './views/themegroups/ThemeGroupDetail.vue';
import ThemeOverview from './views/themes/ThemesOverview.vue';
import ThemeDetail from './views/themes/ThemesDetails.vue';
import Layers3DOverview from './views/layers3d/Layers3DOverview.vue';
import Layers3DDetail from './views/layers3d/Layers3DDetails.vue';
import TableResultsOverview from './views/tableResults/TableResultsOverview.vue';
import TableResultDetail from './views/tableResults/TableResultDetail.vue';
import DomainOverview from './views/domains/DomainOverview.vue';
import DomainDetail from './views/domains/DomainDetail.vue';
import TablesOverview from './views/tables/NedGlobeServicesTablesOverview.vue';
import WebThemeOverview from './views/webthemes/WebThemeOverview.vue';
import WebThemeDetail from './views/webthemes/WebThemeDetail.vue';
import FeedbackOverview from './views/feedbacks/FeedbackOverview.vue';
import FeedbackDetail from './views/feedbacks/FeedbackDetail.vue';
import FeedbackCategory from './views/feedbacks/FeedbackCategory.vue';
import ProfileOverview from './views/profiles/ProfilesOverview.vue';
import ProfileDetail from './views/profiles/ProfilesDetail.vue';
import UserGroupOverview from './views/userGroups/UserGroupOverview.vue';
import UserGroupDetail from './views/userGroups/UserGroupDetail.vue';
import UserOverview from './views/users/UsersOverview.vue';
import UserDetail from './views/users/UsersDetail.vue';
import Controle from './views/controle/Controle.vue';
import BitmapsOverview from './views/bitmaps/BitmapsOverview.vue';
import BitmapsDetail from './views/bitmaps/BitmapsDetail.vue';
import OrganizationOverview from './views/organizations/OrganizationsOverview.vue';
import OrganizationDetail from './views/organizations/OrganizationsDetail.vue';
import FunctionResults from './views/functionresults/FunctionResultsOverview.vue';
import CooperationOverview from './views/cooperation/CooperationOverview.vue';
import CooperationDetail from './views/cooperation/CooperationDetail.vue';
import NewsItemOverview from './views/newsitems/NewsItemsOverview.vue';
import NewsItemDetail from './views/newsitems/NewsItemsDetail.vue';
import MsgFeedDetail from './views/msgFeed/MsgFeedDetail.vue';
import ReleaseNoteOverview from './views/releasenotes/ReleaseNotesOverview.vue';
import ReleaseNoteDetail from './views/releasenotes/ReleaseNotesDetail.vue';
import UrlConnectionLicensesOverview from './views/urlConnections/UrlConnectionLicensesOverview.vue';
import UrlConnectionLicensesDetail from './views/urlConnections/UrlConnectionLicensesDetail.vue';
import StatisticsMain from './views/statistics/StatisticsMain.vue';
import PolygonPatterns from './views/polygonPatterns/PolygonPatterns.vue';
import UsagePage from './views/statistics/usage/index.vue';
import UsageDisplay from './components/dashboard/usage/usage.vue';
import UsageDownload from './components/dashboard/usage/download/index.vue';
import WebJobs from './views/webjobs/WebJobs.vue';
import Errorlog from './views/errorlog/Errorlog.vue';
import SearchInCache from './views/searchcache/SearchInCache.vue';
import UrlConnectionsOverview from './views/urlConnections/UrlConnectionsOverview.vue';
import UrlConnectionsDetail from './views/urlConnections/UrlConnectionsDetail.vue';
import ApiSettingsOverview from './views/apiSettings/ApiSettingsOverview.vue';
import ApiSettingsDetail from './views/apiSettings/ApiSettingsDetail.vue';
import MainSettings from './views/apiSettings/MainSettings.vue';
import OrganizationApisettingsOverview from './views/apiSettings/OrganizationApisettingsOverview.vue';
import OrganizationApisettings from './views/apiSettings/OrganizationApisettings.vue';
import NedBrowser from './views/nedbrowser/NedBrowserImport.vue';
// SonarQube: Built-in objects should not be overridden => Map (https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Map)
import Portal from './views/portal/Portal.vue';
import Conditions from './views/Conditions.vue';
import Printing from './views/printing/Printing.vue';
import SecuredUrl from './views/SecuredUrl.vue';
import DashboardLogs from './views/logging/DashboardLogs.vue';
import DashboardAlerts from './views/logging/DashboardAlerts.vue';
import Products from './views/products/ProductsOverview.vue';

Vue.use(Router);

function navigateToPortal(authorisations) {
    return authorisations.has_portal_license ? authorisations.has_portal_license : '*';
}


function redirectAuthorizedUser(path, authorisations, next) {
    const toPortal = navigateToPortal(authorisations);

    switch (path) {
        case '/mobile':
        case '/mobile/':
            if (!authorisations.has_mobile_license) {
                next('/error/mobile_no_license');
            } else {
                next();
            }
            break;
        case '/portal':
            next(toPortal);
            break;
        default:
            if (authorisations.isAdmin) {
                // Only admin may go to Dashboard
                next();
            } else {
                next('/error/dashboard_noaccess');
            }
    }
}

const parsingId = (route) => ({ id: Number(route.params.id) });
const parsingIdAndCopyMode = (route) => ({ id: Number(route.params.id), copyMode: true });
const parsingIdAndProfileBaseLayer = (route) => ({ id: Number(route.params.id), isProfileBaseLayer: true });
const parsingIdAndProfileThemeFeedback = (route) => ({ id: Number(route.params.id), isProfileThemeFeedback: true });
const parsingIdAndProfileApi = (route) => ({ id: Number(route.params.id), isProfileApi: true });
const parsingIdAndSearch = (route) => ({ id: Number(route.params.id), searchtext: route.params.searchtext });
const parsingImage = (route) => ({ id: Number(route.params.id), metadata: route.params.metadata });
const parsingErrorMessage = (route) => ({ message: route.params.message });
const parsingIdAndNameAndUrl = (route) => ({ id: Number(route.params.id), name: route.params.name, url: route.params.url });
const accessDeniedPath = '/accessDenied';
const conditionsPath = '/conditions';

const router = new Router({
    mode: 'history',
    linkActiveClass: 'is-active',
    routes: [
        // Portal
        {
            path: '/portal',
            name: 'portal',
            component: Portal,
            props: true,
            meta: {
                requiresAuthentication: false,
                title: 'NedGlobe Geo portaal'
            }
        },
        // Dashboard
        {
            path: '/',
            redirect: '/dashboard'
        },
        {
            path: '/dashboard',
            name: 'dashboard',
            component: Dashboard,
            meta: { requiresAuthentication: true }
        },
        // OWS
        {
            path: '/dashboard/ows',
            name: 'owsOverview',
            component: OwsOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/ows/detail/:id',
            name: 'owsDetail',
            component: OwsDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/ows/new',
            name: 'owsDetailNew',
            component: OwsDetail,
            meta: { requiresAuthentication: true }
        },
        // ThemeGroups
        {
            path: '/dashboard/themegroups',
            name: 'themegroupOverview',
            component: ThemeGroupsOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/themegroups/new',
            name: 'themeGroupNew',
            component: ThemeGroupDetail,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/themegroups/:id',
            name: 'themeGroupDetail',
            component: ThemeGroupDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        // Themelayers
        {
            path: '/dashboard/themelayers',
            name: 'themelayerOverview',
            component: ThemeLayerOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/themelayer/detail/:id',
            name: 'themeLayerDetail',
            component: ThemeLayerDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/themelayer/new',
            name: 'themeLayerDetailNew',
            component: ThemeLayerDetail,
            meta: { requiresAuthentication: true }
        },
        // Themes
        {
            path: '/dashboard/themes',
            name: 'themeOverview',
            component: ThemeOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/theme/detail/:id',
            name: 'themesDetail',
            component: ThemeDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/theme/new',
            name: 'themesDetailNew',
            component: ThemeDetail,
            meta: { requiresAuthentication: true }
        },
        // 3D Layers
        {
            path: '/dashboard/layers3D',
            name: 'layers3DOverview',
            component: Layers3DOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/layers3D/detail/:id',
            name: 'layers3DDetail',
            component: Layers3DDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/layers3D/new',
            name: 'layers3DNew',
            component: Layers3DDetail,
            meta: { requiresAuthentication: true }
        },
        // Tableresults
        {
            path: '/dashboard/tableresults',
            name: 'tableresultsOverview',
            component: TableResultsOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/tableresults/new',
            name: 'tableResultNew',
            component: TableResultDetail,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/tableresults/:id',
            name: 'tableResultDetail',
            component: TableResultDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        // DataImport
        {
            path: '/dashboard/dataimport',
            name: 'dataImport',
            component: DataImport,
            meta: { requiresAuthentication: true }
        },
        // FME DataImport
        {
            path: '/dashboard/fmeimportresults',
            name: 'fmeImportResults',
            component: FmeImportResults,
            meta: { requiresAuthentication: true }
        },
        // Domains
        {
            path: '/dashboard/domains',
            name: 'domainOverview',
            component: DomainOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/domain/detail/:id',
            name: 'domainDetail',
            component: DomainDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/domain/new',
            name: 'domainDetailNew',
            component: DomainDetail,
            meta: { requiresAuthentication: true }
        },
        // NedGlobe Services Tables
        {
            path: '/dashboard/tables',
            name: 'TablesOverview',
            component: TablesOverview,
            meta: { requiresAuthentication: true }
        },
        // Web themes
        {
            path: '/dashboard/webthemes',
            name: 'webthemeOverview',
            component: WebThemeOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/webtheme/detail/:id',
            name: 'webThemeDetail',
            component: WebThemeDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/webtheme/detail/copy/:id',
            name: 'webThemeDetailCopy',
            props: parsingIdAndCopyMode,
            component: WebThemeDetail,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/webtheme/new',
            name: 'webThemeDetailNew',
            component: WebThemeDetail,
            meta: { requiresAuthentication: true }
        },
        // Feedbacks
        {
            path: '/dashboard/feedbacks',
            name: 'feedbackOverview',
            component: FeedbackOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/feedback/detail/:id',
            name: 'feedbackDetail',
            component: FeedbackDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/feedback/new',
            name: 'feedbackDetailNew',
            component: FeedbackDetail,
            meta: { requiresAuthentication: true }
        },
        // Feedback copy
        {
            path: '/dashboard/feedback/detail/copy/:id',
            name: 'feedbackDetailCopy',
            props: parsingIdAndCopyMode,
            component: FeedbackDetail,
            meta: { requiresAuthentication: true }
        },
        // Feedbacks category
        {
            path: '/dashboard/feedbackCategory',
            name: 'feedbackCategory',
            component: FeedbackCategory,
            meta: { requiresAuthentication: true }
        },
        // Profiles
        {
            path: '/dashboard/profiles',
            name: 'profileOverview',
            component: ProfileOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesBaseLayer/detail/:id?',
            name: 'profileBaseLayerDetail',
            component: ProfileDetail,
            props: parsingIdAndProfileBaseLayer,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesBaseLayer/new',
            name: 'profileBaseLayerDetailNew',
            component: ProfileDetail,
            props: { isProfileBaseLayer: true },
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesThemeFeedback/detail/:id?',
            name: 'profilesThemeFeedbackDetail',
            component: ProfileDetail,
            props: parsingIdAndProfileThemeFeedback,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesThemeFeedback/new',
            name: 'profilesThemeFeedbackDetailNew',
            component: ProfileDetail,
            props: { isProfileThemeFeedback: true },
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesApi/new',
            name: 'profilesApiDetailNew',
            component: ProfileDetail,
            props: { isProfileApi: true },
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/profilesApi/detail/:id?',
            name: 'profilesApiDetail',
            component: ProfileDetail,
            props: parsingIdAndProfileApi,
            meta: { requiresAuthentication: true }
        },
        // UserGroups
        {
            path: '/dashboard/userGroups',
            name: 'userGroupOverview',
            component: UserGroupOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/userGroup/detail/:id',
            name: 'userGroupDetail',
            component: UserGroupDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/userGroup/new',
            name: 'userGroupDetailNew',
            component: UserGroupDetail,
            meta: { requiresAuthentication: true }
        },
        // Users
        {
            path: '/dashboard/users',
            name: 'userOverview',
            component: UserOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/user/detail/:id',
            name: 'userDetail',
            component: UserDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/user/new',
            name: 'userDetailNew',
            component: UserDetail,
            meta: { requiresAuthentication: true }
        },
        // Controle
        {
            path: '/dashboard/controle',
            name: 'controle',
            component: Controle,
            meta: { requiresAuthentication: true }
        },
        // Bitmaps
        {
            path: '/dashboard/bitmaps',
            name: 'bitmapsOverview',
            component: BitmapsOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/bitmap/detail/:id',
            name: 'BitmapsDetail',
            component: BitmapsDetail,
            props: parsingImage,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/bitmap/new',
            name: 'BitmapsDetailNew',
            component: BitmapsDetail,
            meta: { requiresAuthentication: true }
        },
        // Settings
        {
            path: '/dashboard/settings',
            name: 'Settings',
            component: OrganizationDetail,
            props: { isSettings: true },
            meta: { requiresAuthentication: true }
        },
        // Printing
        {
            path: '/dashboard/printing',
            name: 'printing',
            component: Printing,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // Organizations
        {
            path: '/dashboard/organizations',
            name: 'organizationOverview',
            component: OrganizationOverview,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/organization/detail/:id',
            name: 'organizationDetail',
            component: OrganizationDetail,
            props: parsingId,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/organization/new',
            name: 'organizationDetailNew',
            component: OrganizationDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/functionresults',
            name: 'functionResults',
            component: FunctionResults,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/products',
            name: 'products',
            component: Products,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // Cooperations
        {
            path: '/dashboard/cooperations',
            name: 'cooperationsOverview',
            component: CooperationOverview,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/cooperation/detail/:id',
            name: 'cooperationDetail',
            component: CooperationDetail,
            props: parsingId,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/cooperation/new',
            name: 'cooperationDetailNew',
            component: CooperationDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // NewsItems
        {
            path: '/dashboard/newsitems/:newsType',
            name: 'newsItemOverview',
            component: NewsItemOverview,
            props: true,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/newsitem/detail/:id/:searchtext?',
            name: 'newsItemDetail',
            component: NewsItemDetail,
            props: parsingIdAndSearch,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/newsitem/new',
            name: 'newsItemDetailNew',
            component: NewsItemDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // MsgFeed
        {
            path: '/dashboard/msgFeed/detail/:id/:searchtext?',
            name: 'msgFeedDetail',
            component: MsgFeedDetail,
            props: parsingIdAndSearch,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/msgFeed/new',
            name: 'msgFeedDetailNew',
            component: MsgFeedDetail,
            meta: { requiresAuthentication: true }
        },
        // ReleaseNotes
        {
            path: '/dashboard/releasenotes',
            name: 'releaseNoteOverview',
            component: ReleaseNoteOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/releasenote/detail/:id/:searchtext?',
            name: 'releaseNoteDetail',
            component: ReleaseNoteDetail,
            props: parsingIdAndSearch,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/releasenote/new',
            name: 'releaseNoteDetailNew',
            component: ReleaseNoteDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // UrlConnectionLicense
        {
            path: '/dashboard/connectionLicenses',
            name: 'urlConnectionLicensesOverview',
            component: UrlConnectionLicensesOverview,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/connectionLicense/detail/:id',
            name: 'urlConnectionLicensesDetail',
            component: UrlConnectionLicensesDetail,
            props: parsingId,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/connectionLicense/new',
            name: 'urlConnectionLicensesNew',
            component: UrlConnectionLicensesDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // MainSettings
        {
            path: '/dashboard/mainSettings',
            name: 'MainSettings',
            component: MainSettings,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // ApiSettings
        {
            path: '/dashboard/apiSettings',
            name: 'apiSettingsOverview',
            component: ApiSettingsOverview,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/apiSettings/detail/:id',
            name: 'apiSettingsDetail',
            component: ApiSettingsDetail,
            props: parsingId,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/apiSettings/new',
            name: 'apiSettingsNew',
            component: ApiSettingsDetail,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        {
            path: '/dashboard/OrganizationApisettingsOverview',
            name: 'OrganizationApisettingsOverview',
            component: OrganizationApisettingsOverview,
            meta: { requiresAuthentication: true }
        },
        {
            path: '/dashboard/OrganizationApisettings/OrganizationApiSetting/:id',
            name: 'organizationApisettings',
            component: OrganizationApisettings,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        // NedBrowser
        {
            path: '/dashboard/NedBrowser',
            name: 'NedBrowser',
            component: NedBrowser,
            meta: { requiresAuthentication: true }
        },
        // Link management Overview
        {
            path: '/dashboard/UrlConnectionsOverview',
            name: 'UrlConnectionsOverview',
            component: UrlConnectionsOverview,
            meta: { requiresAuthentication: true }
        },
        // Link management Detail
        {
            path: '/dashboard/connections/detail/:id',
            name: 'UrlConnectionsDetail',
            component: UrlConnectionsDetail,
            props: parsingId,
            meta: { requiresAuthentication: true }
        },
        // Polygon patterns
        {
            path: '/dashboard/PolygonPatterns/:user',
            name: 'PolygonPatterns',
            component: PolygonPatterns,
            props: true,
            meta: { requiresAuthentication: true }
        },
        // DashboardLogs
        {
            path: '/dashboard/dashboardlogs',
            name: 'dashboardLogs',
            component: DashboardLogs,
            meta: { requiresAuthentication: true }
        },
        // DashboardAlerts
        {
            path: '/dashboard/dashboardalerts',
            name: 'dashboardAlerts',
            component: DashboardAlerts,
            meta: { requiresAuthentication: true }
        },
        // Statistics
        {
            path: '/dashboard/statistics',
            name: 'statisticsMain',
            component: StatisticsMain,
            meta: { requiresAuthentication: true }
        },
        // Usage
        {
            path: '/dashboard/statistics/usage',
            component: UsagePage,
            children: [
                {
                    path: '',
                    name: 'usageDisplay',
                    meta: { requiresAuthentication: true },
                    component: UsageDisplay,
                },
                {
                    path: 'export',
                    name: 'usageDownload',
                    meta: { requiresAuthentication: true },
                    component: UsageDownload,
                }
            ]
        },
        // WebJobs
        {
            path: '/dashboard/webJobs',
            name: 'webJobs',
            component: WebJobs,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // Errorlog
        {
            path: '/dashboard/errorlog',
            name: 'errorlog',
            component: Errorlog,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // SearchInCache
        {
            path: '/dashboard/searchInCache',
            name: 'searchInCache',
            component: SearchInCache,
            meta: { requiresAuthentication: true, requiresSuperUser: true }
        },
        // ErrorMessage
        {
            path: '/error/:message?',
            name: 'errorMessage',
            component: ErrorMessage,
            props: parsingErrorMessage,
        },
        //Logout route
        {
            path: '/logout',
            name: 'logout'
        },
        // Dashboard access denied
        {
            path: accessDeniedPath,
            name: 'accessDenied',
            component: accessDenied
        },
        // Conditions
        {
            path: conditionsPath,
            name: 'conditions',
            component: Conditions
        },
        // SecuredUrl
        {
            path: '/securedUrl/:id/:name/:url',
            name: 'securedUrl',
            props: parsingIdAndNameAndUrl,
            component: SecuredUrl
        },
        // Other paths
        {
            path: '*',
            name: 'accessDeniedCatchAll',
            redirect: to => {
                const nonDashboardApps = ['/mobile', '/web', '/portal', '/error'];
                const { path } = to;
                // Probable mistakes in mobile/web/portal URL's
                if (nonDashboardApps.some(a => path.startsWith(a))) {
                    return '/error/access_denied';
                } else {
                    // This shows the Dashboard access Denied page
                    return '/error/access_denied';
                }
            }
        },
    ]
});

/**
 * Set isIE flag
 * @return {Boolean} [description]
 */
router.isIE = function () {
    if (store.getters.isIe === null) {
        const uagent = navigator.userAgent.toLowerCase();
        const isIe = /msie/.test(uagent) || /trident/.test(uagent);
        // set store value
        store.dispatch('setIsIeState', isIe);
    }
    return store.getters.isIe;
};

/**
* Global route guard
* @param  {string} to the target route
* @param  {string} from the current route
* @param  {string} next to resolve the hook
*/
router.beforeEach(async (to, from, next) => {
    if (!store.state.appConfig) {
        await store.dispatch('setApplicationConfiguration');
    }

    if (to.path === '/logout') {
        store.dispatch('logout');
        next(false);
        return;
    }
    if (to.matched.some(record => record.meta.requiresAuthentication)) {

        // We assume we always get exactly 1 matched page
        var matched = to.matched[0];

        // authentication required, IE is not supported
        store.commit('SET_REQUIRES_AUTHENTICATION', true);
        if (router.isIE()) {
            next('/error/access_denied_ie');
            return;
        }
        try {
            await store.dispatch('login');
            const authorisations = await store.dispatch('getUserAuthentication');

            // Normal authorization is default
            let authorized = authorisations.isAuthorized;

            // Except for superuser pages, we then need superuser access
            if (matched.meta.requiresSuperUser) {
                authorized = authorisations.isSuper;
            }

            if (authorized) {
                redirectAuthorizedUser(to.path, authorisations, next);
            } else {

                // Redirect to unknown user page when not authorized.
                next('/error/unknown_user');
            }
        } catch (err) {
            next('/error/unknown_user');
        }
    } else {
        store.commit('SET_REQUIRES_AUTHENTICATION', false);
        next();
    }
    document.title = to.meta.title || 'NedGlobe Dashboard';
    // Set the value of isMobile state
    store.dispatch('setIsMobileState', to.fullPath.toLowerCase().startsWith('/mobile'));
});

export default router;
